import { EvaChartStates } from "types/factory";

import { DataEnum } from "models";
import { ChartSeries } from "models/model";

import { checkSeriesDataXDateGreaterThanMin } from "./utils/checkSeriesDataXDateGreaterThanMin";
import { checkSeriesDataXDateLessThanMax } from "./utils/checkSeriesDataXDateLessThanMax";
import { convertToNumber } from "./utils/convertToNumber";

export function wellContributionLocks(states: Partial<EvaChartStates>) {
  const { locks, layout } = states;

  let lockedXMinType = undefined;
  let lockedXMaxType = undefined;

  const series = [
    {
      x: layout.xAxis.data
    }
  ] as ChartSeries[];

  const isUserXMinLock = locks?.xMin?.type !== DataEnum.DefaultDate && locks?.xMin?.value;
  const isUserXMaxLock = locks?.xMax?.type !== DataEnum.DefaultDate && locks?.xMax?.value;

  const lockedXMin =
    locks?.xMin?.type === DataEnum.Reset
      ? undefined
      : isUserXMaxLock || isUserXMinLock //save the lock value if the user inputs a lock for either min or max
      ? locks?.xMin?.value
      : checkSeriesDataXDateGreaterThanMin("2000", series);

  const lockedXMax =
    locks?.xMax?.type === DataEnum.Reset
      ? undefined
      : isUserXMaxLock || isUserXMinLock //save the lock value if the user inputs a lock for either min or max
      ? locks?.xMax?.value
      : checkSeriesDataXDateLessThanMax("2050", series);

  const lockedYMin =
    locks?.yMin?.type === DataEnum.Reset ? undefined : locks?.yMin?.value;

  const lockedYMax =
    locks?.yMax?.type === DataEnum.Reset ? undefined : locks?.yMax?.value;

  // If initial lock was undefined, chart has just been switched to and the lock has been set
  // meaning the data has gone beyond the bounds of the lock
  // We will use DefaultDate to track this state until the lock is reset
  if ((!locks?.xMin?.value && lockedXMin) || locks?.xMin?.type === DataEnum.DefaultDate) {
    lockedXMinType = DataEnum.DefaultDate;
  }

  if ((!locks?.xMax?.value && lockedXMax) || locks?.xMax?.type === DataEnum.DefaultDate) {
    lockedXMaxType = DataEnum.DefaultDate;
  }

  return {
    lockedXMin: lockedXMin,
    lockedXMax: lockedXMax,
    lockedYMin: convertToNumber(lockedYMin),
    lockedYMax: convertToNumber(lockedYMax),
    lockedXMinType,
    lockedXMaxType
  };
}
